import { service } from '@ember/service';
import Transform from '@ember-data/serializer/transform';
import type { Dayjs } from 'dayjs';
import type HotelAndMarketService from 'lumen/services/hotel-and-market';

export default class HoteldateTransform extends Transform {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketService;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deserialize(serialized: string) {
    if (serialized) {
      return this.hotelAndMarketService.toLocalTime(
        serialized.split('T')[0] as string,
      );
    }

    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serialize(deserialized: Dayjs) {
    if (deserialized) {
      return deserialized.format('YYYY-MM-DD');
    }

    return deserialized;
  }
}

export type HoteldateTransformReturn = ReturnType<
  HoteldateTransform['deserialize']
>;
